import EventActionProto from '../event-action-proto';
import SessionLoader from "core/gd/data/session-loader";

export default class SessionTaskTagNew extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            task        : {id: sessionEvent.data.taskId}, //sessionEvent.taskId,
            isBulkUpdate: sessionEvent.isBulkUpdate, // probably it should be true on import tasks otherwise currently there is no way to bulk add tasks
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        // this.data format
        // {
        //     taskId,
        //     tagId
        // }

        // console.log("SessionTaskNew process", this);

        gd.modelBus.newUpdate('task-tag', this.method, this.header.taskId, this.data, this.header);
    }
};
